import { scale } from 'd3'; /* importing everything...isnt that too big */

export const thematicTopics = {
  npc: {
    colorCode: '#858e92',
  },
  manufacture: {
    colorCode: '#C6A87E',
  },
  transfers: {
    colorCode: '#608372',
  },
  brokering: {
    colorCode: '#875D60',
  },
  stockpile: {
    colorCode: '#637285',
  },
  collection: {
    colorCode: '#C0AA9D',
  },
  marking: {
    colorCode: '#706E6A',
  },
  tracing: {
    colorCode: '#59687D',
  },
  assistance: {
    colorCode: '#879CBC',
  },
  submitted: {
    colorCode: '#333',
  }
};

export const thematicTopicsBySlug = {
  'point-of-contact': {
    colorCode: thematicTopics.npc.colorCode,
  },
  manufacture: {
    colorCode: thematicTopics.manufacture.colorCode,
  },
  'international-transfers': {
    colorCode: thematicTopics.transfers.colorCode,
  },
  brokering: {
    colorCode: thematicTopics.brokering.colorCode,
  },
  'stockpile-management': {
    colorCode: thematicTopics.stockpile.colorCode,
  },
  collection: {
    colorCode: thematicTopics.collection.colorCode,
  },
  'making-and-record-keeping': {
    colorCode: thematicTopics.marking.colorCode,
  },
  'international-tracing': {
    colorCode: thematicTopics.tracing.colorCode,
  },
  'international-cooperation-and-assistance': {
    colorCode: thematicTopics.assistance.colorCode,
  },
  'information-and-files-to-be-submitted': {
    colorCode: thematicTopics.submitted.colorCode
  }
};

export const defaultAssistanceColor = '#444';

export const assistanceTopics = {
  manufacture: {
    fullTopicName: 'Laws, regulations, procedures on manufacturing',
    abbreviation: 'Manuf',
    colorCode: '#C6A87E',
  },

  transfers: {
    fullTopicName: 'Laws, regulations, procedures on international transfers',
    abbreviation: 'Transf',
    colorCode: '#608372',
  },

  brokering: {
    fullTopicName: 'Laws, regulations, procedures on brokering',
    abbreviation: 'Brok',
    colorCode: '#875D60',
  },

  stockpile: {
    fullTopicName: 'Standards and procedures on stockpile management',
    abbreviation: 'Stockp',
    colorCode: '#637285',
  },

  destruction: {
    fullTopicName: 'Capacity for destruction',
    abbreviation: 'Destr',
    colorCode: '#C0AA9D',
  },

  seizure: {
    fullTopicName: 'Capacity for confiscation and seizure',
    abbreviation: 'Seiz',
    colorCode: '#C0AA9D',
  },

  recordkeeping: {
    fullTopicName: 'Capacity for record-keeping',
    abbreviation: 'RecKp',
    colorCode: '#706E6A',
  },

  tracing: {
    fullTopicName: 'Procedures to trace SALW',
    abbreviation: 'Traci',
    colorCode: '#59687D',
  },

  npc: {
    fullTopicName: 'National coordination mechanism / NPC',
    abbreviation: 'NPC',
  },

  ddr: {
    fullTopicName: 'Disarmament support and put in place development',
    abbreviation: 'DDR',
  },

  training: {
    fullTopicName: 'Capacity-building and training on SALW issues',
    abbreviation: 'Train',
  },

  law: {
    fullTopicName: 'Law enforcement',
    abbreviation: 'LawEnf',
  },

  borders: {
    fullTopicName: 'Customs and borders',
    abbreviation: 'Border',
  },

  research: {
    fullTopicName: 'Action-oriented research',
    abbreviation: 'Research',
  },

  children: {
    fullTopicName: 'Children and youth',
    abbreviation: 'Children',
  },

  awareness: {
    fullTopicName: 'Awareness-raising',
    abbreviation: 'Awareness',
  },

  crime: {
    fullTopicName: 'Organized crime, drug trafficking and terrorism',
    abbreviation: 'Crime',
  },
};

/* Categorical coloring: A dictionary is not enough, we need to create a d3 color scale to hand it over to rd3 */
export const answerColorScale = scale
  .ordinal()
  .domain(['Yes', 'No', 'Developing', 'NA'])
  //.range(["#3182bd", "#A45B05", "#CED24F", "#BDBDBD"]);
  .range(['#82ca9d', '#ff9e6b', '#8282c9', '#999']);

export const answerColorDict = {
  Yes: '#67c292',
  No: '#d46565',
  Developing: '#97bed8',
  'N/A': '#aaa',
  'No data*': '#cccccc',
};

export function getThematicColor(topicIdentifier){
  const defaultColor="#f00";
  const color = thematicTopics[topicIdentifier]
    ? thematicTopics[topicIdentifier].colorCode
    : defaultColor;
  return color;
}

export function getThematicColorBySlug(topicIdentifier){
  const defaultColor="#f00";
  const color = thematicTopicsBySlug[topicIdentifier]
    ? thematicTopicsBySlug[topicIdentifier].colorCode
    : defaultColor;
  return color;
}



// WEBPACK FOOTER //
// ./src/resources/thematic-topics.js